// constructor for Calculation Item object
// create CalculationItem object from DB object item
function CalculationItem(item) {
  let itemOrigin = item;
  this.id = item.id;
  this.calculationUid = item.calculation_uid;
  this.shapeId = item.shapes_id;
  this.name = item.name;
  this.thickness = item.price_list_item.thickness.name;
  this.priceListItem = item.pricelist_items_id;
  this.dimensions = item.dimensions;
  this.area = item.area;
  this.areaWithCutoff = item.area_with_cutoff;
  this.weight = item.weight;
  this.orientation = item.orientation;
  this.directional = item.directional;
  this.surface = item.surface;
  this.impregnation = item.impregnation;
  this.calculationTransportationsId = item.calculation_transportations_id;
  this.calculationAssemblyId = item.calculation_assembly_id;
  this.perimetr = item.perimeter;
  this.perimeter_as_side = item.perimeter_as_side;
  this.manipulation_koef = item.manipulation_koef;
  this.actions = null;
  this.assemblyItems = [];

  // action resolver
  let actionHashTable = {}
  if (item.actions) {
    item.actions.forEach((action) => {
      if (action.action_group !== 'rezani') {
        actionHashTable[action.actions_id] = {
          action_origin: action.action === null ? null : action.action?.action_id,
          related_to: action.related_to,
          unit_count: action.unit_count,
          sides: action.sides
        }
      }
    })
    this.actions = actionHashTable
  } else {
    this.actions = null;
  }

  // assembly_items resolver
  if (item.assembly_items) {
    this.assemblyItems = item.assembly_items.map(obj => ({
      id: obj.price_list_individual_item_id,
      originItem: obj.id,
      sides: obj.sides,
      unitCount: obj.unit_count, }))
  } else {
    this.assemblyItems = [];
  }

  Object.defineProperty(this, 'itemOrigin', {
    get: () => {
      return itemOrigin
    }
  })
}

export default CalculationItem;